import styled from 'styled-components';
import { Paper } from '@mui/material';

// TODO:
// Created to mantain the old card style acrosss the app
// Today (29-12-2025) its duplicated in two more places (THAT WE KNOW): Alerts.styled.ts AND Alarms.styled.ts
// That should be refactored to use this component instead
// It is an old style, we should make a new defauld component
export const Card = styled(Paper)`
  padding: 1.25rem;
  margin-bottom: 2.5rem;
  &.MuiPaper-root {
    border: 1px solid #eff1f3;
    box-sizing: border-box;
    box-shadow: 0 4px 1px rgba(0, 0, 0, 0.1), 0 8px 10px rgba(17, 17, 26, 0.1);
  }
  &.MuiPaper-rounded {
    border-radius: 10px;
  }
`;

export const CardHeader = styled.div(
  ({ expanded }: { expanded: boolean }) => `
    display: flex;
    justify-content: flex-start;
    align-items:center;
    padding-bottom: ${expanded ? '0.75' : '0'}rem;

    & > .MuiTypography-root {
      font-weight: 500;
    }

    & > .MuiButton-root {
      padding: 0 0.25rem;
      font-weight: 400;
      margin-right: 1.5rem;
    }
  `
);
